import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject, filter, take, takeUntil } from 'rxjs';
import brandInfo from "src/environments/brand.json";
import { lamboUnlimitedTermYear } from "src/app/_helpers/lambo-unlimited-term-year";
import { resolveFooterDeductible } from "src/app/_helpers/footer-deductible";

@Component({
  selector: 'app-mobile-plan-footer',
  standalone: false,
  templateUrl: './mobile-plan-footer.component.html',
  styleUrls: ['./mobile-plan-footer.component.scss']
})
export class MobilePlanFooterComponent implements OnInit, OnChanges, OnDestroy {

  @Input() plan: any;
  @Output() emitAddToCart = new EventEmitter<string>();
  destroy$ = new Subject<void>();
  currentPlan: any;
  brand: string;

  constructor(private translate: TranslateService, public store: Store<{ selectedPlan: any }>) { }



  ngOnInit(): void {
    this.brand = brandInfo.brand;
    if (this.plan) {
      this.currentPlan = this.plan;
    }
    this.store.select((store) => store.selectedPlan).pipe(
      filter(val => val),
      takeUntil(this.destroy$),
    ).subscribe((val) => {
      this.applyCurrentPlanFromState(val);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['plan'] && this.plan) {
      this.store
        .select((s) => s.selectedPlan)
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe((val) => this.applyCurrentPlanFromState(val));
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Sticky footer must show the same deductible as desktop; store currentSelectedPlan often lacks
   * term.deductible on first paint while allPlansPlanBasedTerm / @Input plan already have it.
   */
  private applyCurrentPlanFromState(val: any): void {
    const fromStore = val?.currentSelectedPlan;
    const base = fromStore || this.plan;
    if (!base) {
      return;
    }
    const d = resolveFooterDeductible({ selectedPlanState: val, inputPlan: this.plan });
    if (d !== null && d !== undefined && d !== '') {
      this.currentPlan = {
        ...base,
        term: { ...(base.term || {}), deductible: d },
      };
    } else {
      this.currentPlan = base;
    }
  }

  addToCart() {
    console.log("addToCart")
    this.emitAddToCart.emit("addToCart");

  }

  lamboFooterUnlimitedYear(): string {
    if (!this.plan?.planTerms?.length || this.plan.term?.termIndex == null) {
      return lamboUnlimitedTermYear(null);
    }
    const idx = this.plan.term.termIndex;
    const t = this.plan.planTerms[idx];
    const raw = t?.planTermSKUName ?? t?.label ?? "";
    return lamboUnlimitedTermYear(raw);
  }

  convertTermLabel(term: string) {
    if (!term || term === "") {
      return "";
    }
    
    if (term.toUpperCase().indexOf(", 0 MILES") > -1) {
      let year = term.split(' ')[0]
      let newTerm = this.translate.instant("CART_CHECKOUT.YEAR_UNLIMITED_MILEAGE", { year: year })
      return newTerm
    }
    else {
      term = term.toUpperCase();
      let years1 = (term.includes(' YEARS') ? term.split(' YEARS') : term.includes(' YEAR(S)') ? term.split(' YEAR(S)') : term.split(' YEAR'));
      let years2 = (term.includes(' YEARS, ') ? term.split(' YEARS, ') : term.includes(' YEAR(S), ') ? term.split(' YEAR(S), ') : term.split(' YEAR, '));
      return (years1[0]) + ' ' + this.translate.instant("GENERIC.YEARS") + ' ' + this.translate.instant("RATES_PAGE.OR") + ' ' + years2[1].split(' ')[0] + ' ' + this.translate.instant("GENERIC.MILEAGE_PLURAL").toLowerCase()
    }
  }
}